var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"seven"},[_c('div',{staticClass:"title"},[_c('p',{staticClass:"text"},[_vm._v("桌面式产品展示")]),_c('img',{staticClass:"cross",attrs:{"src":require("../assets/img/cross.png"),"alt":""}})]),_c('div',{staticClass:"human"},[_c('img',{attrs:{"src":require("../assets/img/human.png"),"alt":""}})])])
}]

export { render, staticRenderFns }